// extracted by mini-css-extract-plugin
export default {"text-field":"SearchBar_text-field__PCsQk","search-container":"SearchBar_search-container__PoyHo"};